import { Calendar, Plus, WalletMinimal, Zap } from 'lucide-react';
import React from 'react';
import ReactImageGallery from 'react-image-gallery';
import { array, string } from 'prop-types';

// Copied directly from
// `node_modules/react-image-gallery/styles/css/image-gallery.css`. The
// copied file is left unedited, and all the overrides are defined in
// the component CSS file below.
// import './image-gallery.css';
import css from './HowSection.module.css';

import ResponsiveImage from '../../../components/ResponsiveImage/ResponsiveImage';
import { FormattedMessage } from '../../../util/reactIntl';

const MAX_MOBILE_SCREEN_WIDTH = 1024;

const HowSection = props => {
  const { sectionId, sectionData } = props;

  const titleText = (sectionData && sectionData[0]?.title?.content) || '';
  const descriptionText = (sectionData && sectionData[0]?.description?.content) || '';
  const blocks = (sectionData && sectionData[0]?.blocks) || [];

  const icons = [
    <Zap></Zap>,
    <Calendar></Calendar>,
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M28.6484 40.7976V39.9089C28.6484 36.4735 31.4334 33.6885 34.8689 33.6885C38.3043 33.6885 41.0893 36.4735 41.0893 39.9089V40.7976" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M34.8709 33.6894C36.834 33.6894 38.4255 32.0979 38.4255 30.1349C38.4255 28.1717 36.834 26.5803 34.8709 26.5803C32.9078 26.5803 31.3164 28.1717 31.3164 30.1349C31.3164 32.0979 32.9078 33.6894 34.8709 33.6894Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <mask id="path-4-inside-1_69_4021" fill="white">
        <path fillRule="evenodd" clipRule="evenodd" d="M50.3281 27.0996C50.3281 24.3382 48.0895 22.0996 45.3281 22.0996H24.4531C21.6917 22.0996 19.4531 24.3382 19.4531 27.0996V40.5049C19.4531 43.2663 21.6917 45.5049 24.4531 45.5049H30.0741C31.0696 45.5049 31.9933 46.0226 32.5128 46.8717C33.6278 48.6942 36.2751 48.6942 37.3902 46.8717C37.9097 46.0226 38.8334 45.5049 39.8288 45.5049H45.3281C48.0895 45.5049 50.3281 43.2663 50.3281 40.5048V27.0996Z" />
      </mask>
      <path d="M24.4531 24.0996H45.3281V20.0996H24.4531V24.0996ZM21.4531 40.5049V27.0996H17.4531V40.5049H21.4531ZM30.0741 43.5049H24.4531V47.5049H30.0741V43.5049ZM45.3281 43.5049H39.8288V47.5049H45.3281V43.5049ZM48.3281 27.0996V40.5048H52.3281V27.0996H48.3281ZM45.3281 47.5049C49.1941 47.5049 52.3281 44.3708 52.3281 40.5048H48.3281C48.3281 42.1617 46.985 43.5049 45.3281 43.5049V47.5049ZM39.0962 47.9155C39.2523 47.6604 39.5298 47.5049 39.8288 47.5049V43.5049C38.1371 43.5049 36.5671 44.3848 35.6841 45.8279L39.0962 47.9155ZM30.8068 47.9155C32.7019 51.013 37.2011 51.013 39.0962 47.9155L35.6841 45.8279C35.3491 46.3755 34.5538 46.3755 34.2188 45.8279L30.8068 47.9155ZM30.0741 47.5049C30.3732 47.5049 30.6507 47.6604 30.8068 47.9155L34.2188 45.8279C33.3359 44.3848 31.7659 43.5049 30.0741 43.5049V47.5049ZM17.4531 40.5049C17.4531 44.3708 20.5871 47.5049 24.4531 47.5049V43.5049C22.7963 43.5049 21.4531 42.1617 21.4531 40.5049H17.4531ZM45.3281 24.0996C46.985 24.0996 48.3281 25.4428 48.3281 27.0996H52.3281C52.3281 23.2336 49.1941 20.0996 45.3281 20.0996V24.0996ZM24.4531 20.0996C20.5871 20.0996 17.4531 23.2336 17.4531 27.0996H21.4531C21.4531 25.4428 22.7963 24.0996 24.4531 24.0996V20.0996Z" fill="white" mask="url(#path-4-inside-1_69_4021)" />
    </svg>,
    <WalletMinimal></WalletMinimal>
  ];

  const getVariantNames = img => {
    const { variants } = img?.attributes || {};
    return variants ? Object.keys(variants) : [];
  };

  const renderItem = item => {
    return (
      <div className={css.imageWrapper}>
        <a href={item.image.callToAction.href}>
          <ResponsiveImage
            rootClassName={css.image}
            image={item.image.media.image}
            alt={item.image.media.alt}
            variants={getVariantNames(item.image.media.image)}
          />
          <div className={css.iconContainer}>
            <div className={css.icon}>
              <div className={css.circle}>
                {icons[item.index]}
              </div>
            </div>
          </div>
          <div className={css.imageOverlay}></div>
          <div className={css.title}>
            {item.image.title.content}
          </div>
          <p>
            {item.image.text.content}
          </p>
          <div className={css.ctaHover}>
            {item.image.callToAction.content}
            <Plus />
          </div>
        </a>
      </div>
    );
  };

  const items = blocks ? blocks.map((block, i) => {
    return {
      // We will only use the image resource, but react-image-gallery
      // requires the `original` key from each item.
      original: '',
      image: block,
      index: i,
    };
  }) : [];

  const hasMatchMedia = typeof window !== 'undefined' && window?.matchMedia;
  const isMobileLayout = hasMatchMedia
    ? window.matchMedia(`(max-width: ${MAX_MOBILE_SCREEN_WIDTH}px)`)?.matches
    : true;

  return (
    <section id={sectionId} className={css.container}>
      <div className={css.wrapper}>
        <div className={css.text}>
          <div className={css.left}>
            <div>
              <h1 className={css.heading}>{titleText}</h1>
            </div>
          </div>
          <div className={css.right}>
            <p className={css.description}>{descriptionText}</p>
          </div>
        </div>
        <div className={css.imageContainer}>
          <div className="howRIG">
            {isMobileLayout ? <ReactImageGallery
              items={items}
              renderItem={renderItem}
              showBullets={true}
              showPlayButton={false}
              showFullscreenButton={false}
              showIndex={false}
              showNav={false}
              showThumbnails={false}
            /> : <div className={css.desktopImageWrapper}>
              {items.map((item, index) => (
                <div key={index} className={css.imageWrapper}>
                  <a href={item.image.callToAction.href}>
                    <ResponsiveImage
                      rootClassName={css.image}
                      image={item.image.media.image}
                      alt={item.image.media.alt}
                      variants={getVariantNames(item.image.media.image)}
                    />
                    <div className={css.iconContainer}>
                      <div className={css.icon}>
                        <div className={css.circle}>
                          {icons[index]}
                        </div>
                      </div>
                    </div>
                    <div className={css.imageOverlay}></div>
                    <div className={css.title}>
                      {item.image.title.content}
                    </div>
                    <p>
                      {item.image.text.content}
                    </p>
                    <div className={css.ctaHover}>
                      {item.image.callToAction.content}
                      <Plus />
                    </div>
                  </a>
                </div>
              ))}
            </div>}
          </div>
        </div>
      </div>
    </section>
  );
};

HowSection.defaultProps = {
  sectionData: {},
};

HowSection.propTypes = {
  sectionId: string.isRequired,
  sectionData: array,
};

export default HowSection;
